import React from "react";
import { Row } from "reactstrap";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { PaginationComponentProps } from "../pagination-component/pagination-component-props";
import "./admin-pagination-component.scss";
import { PaginationItem } from "@mui/material";
import {
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded,
} from "@mui/icons-material";

const AdminPaginationComponent: React.FC<PaginationComponentProps> = ({
  totalRecords,
  pageSize,
  currentPage,
  onPageChange,
}) => {
  const pageCount = Math.ceil(totalRecords / pageSize) || 1;

  return (
    <Row className="admin-pagination-component">
      <Stack spacing={2}>
        <Pagination
          count={pageCount}
          page={currentPage}
          onChange={onPageChange}
          variant="outlined"
          shape="rounded"
          boundaryCount={1}
          siblingCount={2}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              slots={{
                previous: KeyboardArrowLeftRounded,
                next: KeyboardArrowRightRounded,
              }}
            />
          )}
        />
      </Stack>
    </Row>
  );
};

export default AdminPaginationComponent;
